<template>
  <!-- <Form v-slot="{ errors }" @submit="submitForm"> -->
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>{{ id ? 'Cập nhật liên hệ' : 'Thêm mới liên hệ' }}</h1>
      <div class="float-right">
        <button
          type="button"
          class="font-medium f12 btn btn-outline-secondary m-r-10"
          @click="$router.push('/customer-support/contact')"
        >
          <b-icon icon="arrow-left" aria-hidden="true" />
          Quay lại
        </button>
        <button
          type="submit"
          class="font-medium f12 btn btn-outline-primary m-r-10"
          @click="submitForm"
          :disabled="isLoading"
        >
          <b-icon icon="check-lg" aria-hidden="true" />
          {{ id ? 'Cập nhật' : 'Thêm mới' }}
        </button>
      </div>
      <hr />
    </div>

    <div class="card-body px-20 pt-0">
      <div>
        <ValidationObserver v-slot="{ handleSubmit }" ref="observer">
          <form @submit.prevent="handleSubmit(submitForm)">
            <b-row>
              <div class="col-md-6 pr-0">
                <div class="card mb-3">
                  <div class="form-item">
                    <ValidationProvider rules="required|mail" vid="email" name="Email">
                      <b-row class="form-group" slot-scope="{ errors }">
                        <b-col cols="3" class="form-label require">Email</b-col>
                        <b-col cols="9" class="form-input">
                          <b-form-input v-model="form.email" placeholder="Email" />
                          <p class="text-danger">{{ errors[0] }}</p>
                        </b-col>
                      </b-row>
                    </ValidationProvider>
                  </div>
                  <div class="form-item">
                    <ValidationProvider rules="required|regexMobile" vid="mobile" name="Mobile">
                      <b-row class="form-group" slot-scope="{ errors }">
                        <b-col cols="3" class="form-label require">Số điện thoại</b-col>
                        <b-col cols="9" class="form-input col-sm-9">
                          <b-form-input v-model="form.mobile" placeholder="Nhập số điện thoại" />
                          <p class="text-danger">{{ errors[0] }}</p>
                        </b-col>
                      </b-row>
                    </ValidationProvider>
                  </div>

                  <div class="form-item">
                    <ValidationProvider rules="required" vid="name" name="Name">
                      <b-row class="form-group" slot-scope="{ errors }">
                        <b-col cols="3" class="form-label require">Tên</b-col>
                        <b-col cols="9" class="form-input col-sm-9">
                          <b-form-input v-model="form.name" placeholder="Name" />
                          <p class="text-danger">{{ errors[0] }}</p>
                        </b-col>
                      </b-row>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="form-item card">
                  <!-- <ValidationProvider rules="" vid="mo" name="Merchant Owner"> -->
                  <b-row class="">
                    <b-col cols="6" class="form-label col-sm-6">
                      <p>
                        Merchant Owner
                        <span class="text-secondary">(Chọn được nhiều)</span>
                      </p>
                    </b-col>
                    <b-col cols="6" class="form-group col-sm-6">
                      <Select2
                        ref="moSelect"
                        required
                        :settings="moSettings"
                        placeholder="Tìm kiếm merchant owner để thêm"
                        @change="onChangeMo"
                      />
                      <p class="text-danger">{{ moError }}</p>
                    </b-col>
                  </b-row>
                  <!-- </ValidationProvider> -->
                  <div class="table-responsive table-mo" style="overflow-y: auto">
                    <table
                      v-if="selectedMoList.length > 0"
                      class="table table-hover table-bordered"
                    >
                      <thead class="thead-light sticky-top bg-white">
                        <tr>
                          <th style="width: auto">Tên</th>
                          <th style="width: 220px">Chức danh</th>
                          <th style="width: 40px"></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="item in selectedMoList" :key="item.id">
                          <td>
                            <b-link
                              target="_blank"
                              class="text-primary"
                              :to="`/customer-support/merchant-owner/${item.id}`"
                            >
                              {{ item.name || item.email }}
                            </b-link>
                          </td>
                          <td>
                            <b-form-select
                              :options="moRoles"
                              v-model="item.role"
                              size="sm"
                              placeholder="Chọn chức danh"
                              @change="updateRole('mo', item.id, $event)"
                            ></b-form-select>
                          </td>
                          <td>
                            <b-button size="sm" variant="danger" @click="removeItem('mo', item.id)">
                              <b-icon icon="trash"></b-icon>
                            </b-button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <p class="text-secondary pt-15 text-center" v-else>Không có dữ liệu</p>
                  </div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-item card mb-3">
                  <!-- <ValidationProvider rules="" vid="ma" name="Merchant Account"> -->
                  <!-- <b-row class="" slot-scope="{ errors }"> -->
                  <b-row class="">
                    <b-col cols="6" class="form-label col-sm-6">
                      <p>
                        Merchant Account
                        <span class="text-secondary">(Chọn được nhiều)</span>
                      </p>
                    </b-col>
                    <b-col cols="6" class="form-group col-sm-6">
                      <Select2
                        ref="maSelect"
                        required
                        :settings="maSettings"
                        placeholder="Tìm kiếm merchant account để thêm"
                        @change="onChangeMa"
                      />
                      <!-- <p class="text-danger">{{ errors[0] }}</p> -->
                      <p class="text-danger">{{ maError }}</p>
                    </b-col>
                  </b-row>
                  <!-- </ValidationProvider> -->
                  <div class="table-responsive" style="overflow-y: auto">
                    <table
                      v-if="selectedMaList.length > 0"
                      class="table table-hover table-bordered"
                    >
                      <thead class="thead-light sticky-top bg-white">
                        <tr>
                          <th style="width: auto">Tên</th>
                          <th style="width: 220px">Chức danh</th>
                          <th style="width: 40px"></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="item in selectedMaList" :key="item.id">
                          <td>
                            <b-link
                              target="_blank"
                              class="text-primary"
                              :to="`/customer-support/account/${item.id}`"
                            >
                              {{ item.name || item.email }}
                            </b-link>
                          </td>
                          <td>
                            <b-form-select
                              placeholder="Chọn chức danh"
                              v-model="item.role"
                              size="sm"
                              :options="maRoles"
                              @change="updateRole('ma', item.id, $event)"
                            ></b-form-select>
                          </td>
                          <td>
                            <b-button size="sm" variant="danger" @click="removeItem('ma', item.id)">
                              <b-icon icon="trash"></b-icon>
                            </b-button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <p class="text-secondary pt-15 text-center" v-else>Không có dữ liệu</p>
                  </div>
                </div>
                <div class="form-item card mb-4">
                  <!-- <ValidationProvider rules="" vid="store" name="Store"> -->
                  <!-- <b-row class="" slot-scope="{ errors }"> -->
                  <b-row class="">
                    <b-col cols="6" class="form-label col-sm-6">
                      <p>
                        Cửa hàng
                        <span class="text-secondary">(Chọn được nhiều)</span>
                      </p>
                    </b-col>
                    <b-col cols="6" class="form-group col-sm-6">
                      <Select2
                        ref="storeSelect"
                        required
                        :settings="storeSettings"
                        placeholder="Tìm kiếm cửa hàng để thêm"
                        @change="onChangeStore"
                      />
                      <!-- <p class="text-danger">{{ errors[0] }}</p> -->
                      <p class="text-danger">{{ storeError }}</p>
                    </b-col>
                  </b-row>
                  <!-- </ValidationProvider> -->
                  <div class="table-responsive" style="overflow-y: auto">
                    <table
                      v-if="selectedStoreList.length > 0"
                      class="table table-hover table-bordered"
                    >
                      <thead class="thead-light sticky-top bg-white">
                        <tr>
                          <th style="width: auto">Tên</th>
                          <th style="width: 220px">Chức danh</th>
                          <th style="width: 40px"></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="item in selectedStoreList" :key="item.id">
                          <td>
                            <b-link
                              target="_blank"
                              class="text-primary"
                              :to="`/customer-support/store/${item.id}`"
                            >
                              {{ item.name || item.email }}
                            </b-link>
                          </td>
                          <td>
                            <b-form-select
                              v-model="item.role"
                              size="sm"
                              :options="storeRoles"
                              @change="updateRole('store', item.id, $event)"
                              placeholder="Chọn chức danh"
                            ></b-form-select>
                          </td>
                          <td>
                            <b-button
                              size="sm"
                              variant="danger"
                              @click="removeItem('store', item.id)"
                            >
                              <b-icon icon="trash"></b-icon>
                            </b-button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <p class="text-secondary pt-15 text-center" v-else>Không có dữ liệu</p>
                  </div>
                </div>
              </div>
            </b-row>
          </form>
        </ValidationObserver>
      </div>
    </div>

    <VueLoadingOverlay :active.sync="isLoading" :is-full-page="true" />
    <!-- </Form> -->
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { showMess } from '@/config/utils'
  import cloneDeep from 'lodash/cloneDeep'
  import { Create, Update, Detail } from '@/services/customer-support/contact'
  import {
    // Detail as MoDetail,
    List as ListMo,
  } from '@/services/customer-support/merchant-owner'
  import {
    // Detail as MaDetail,
    Search as ListMa,
  } from '@/services/customer-support/account'
  import {
    // Detail as StoreDetail,
    List as ListStore,
  } from '@/services/customer-support/store'
  import { CommonService } from '@/services/common.service'

  export default {
    name: 'CreateContact',
    components: {},
    data() {
      return {
        isLoading: false,
        id: null,
        selectedMoList: [],
        selectedMaList: [],
        selectedStoreList: [],
        listSearchMo: [],
        listSearchMa: [],
        listSearchStore: [],
        moRoles: [],
        maRoles: [],
        storeRoles: [],
        moError: '',
        maError: '',
        storeError: '',
        moId: '',
        maId: '',
        storeId: '',
        form: {
          email: '',
          maContactList: [],
          moContactList: [],
          mobile: '',
          name: '',
          note: '',
          status: '',
          storeContactList: [],
        },

        tLoadMo: undefined,
        moSettings: {
          ajax: {
            delay: 500,
            transport: (params, success, failure) => {
              const txtSearch = params.data?.q?.trim() || ''
              if (!txtSearch) {
                return success({
                  results: [],
                })
              }

              // const queryString = txtSearch ? `{textSearch} LIKE '''${txtSearch}'''` : ''

              let queryString = `{textSearch} like '''${txtSearch}'''`
              // Thêm điều kiện loại trừ các ID đã chọn
              if (this.selectedMoList.length > 0) {
                const excludeIds = this.selectedMoList.map(mo => `'''${mo.id}'''`).join(' , ')
                queryString += ` and {id} nin [${excludeIds}]`
              }

              if (this.tLoadMo) {
                clearTimeout(this.tLoadMo)
              }
              this.tLoadMo = setTimeout(() => {
                ListMo({
                  showFields: ['id', 'ownerName', 'email'],
                  limit: 10,
                  page: 1,
                  queryString,
                  // keyWord: txtSearch,
                  sort: {
                    direction: 'ASC',
                    properties: ['ownerName'],
                  },
                })
                  .then(res => {
                    this.listSearchMo = res.data.list?.map(item => {
                      return {
                        ...item,
                        id: item.id,
                        text: item.ownerName || item.email,
                      }
                    })
                    success({
                      results: this.listSearchMo,
                    })
                    // success({
                    //   results:
                    //     res.data.list?.map((item) => {
                    //       return {
                    //         ...item,
                    //         id: item.id,
                    //         text: item.ownerName || item.email,
                    //       };
                    //     }) || [],
                    // });
                  })
                  .catch(failure)
              }, 500)
            },
          },
        },

        tLoadMa: undefined,
        maSettings: {
          ajax: {
            delay: 500,
            transport: (params, success, failure) => {
              const txtSearch = params.data?.q?.trim() || ''
              if (!txtSearch) {
                return success({
                  results: [],
                })
              }

              // const querys = [`{textSearch} LIKE '''${txtSearch}'''`];
              // if (this.moId) {
              //   querys.push(`{merchantOwnerId} == '''${this.moId}'''`);
              // }
              let queryString = `{textSearch} like '''${txtSearch}'''`

              if (this.moId) {
                queryString += ` and {merchantOwnerId} == '''${this.moId}'''`
              }

              if (this.selectedMaList.length > 0) {
                const excludeIds = this.selectedMaList.map(ma => `'''${ma.id}'''`).join(' , ')
                queryString += ` and {id} nin [${excludeIds}]`
              }

              if (this.tLoadMa) {
                clearTimeout(this.tLoadMa)
              }
              this.tLoadMa = setTimeout(() => {
                ListMa({
                  showFields: ['id', 'accountName', 'email', 'role', 'merchantOwnerId'],
                  limit: 10,
                  page: 1,
                  queryString,
                  sort: {
                    direction: 'ASC',
                    properties: ['accountName'],
                  },
                })
                  .then(res => {
                    this.listSearchMa =
                      res.data.listData?.map(item => {
                        return {
                          ...item,
                          id: item.id,
                          text: item.accountName || item.email,
                          merchantOwnerId: item.merchantOwnerId,
                        }
                      }) || []
                    success({
                      results: this.listSearchMa,
                    })
                  })
                  .catch(failure)
              }, 500)
            },
          },
        },

        tLoadStore: undefined,
        storeSettings: {
          ajax: {
            delay: 500,
            transport: (params, success, failure) => {
              const txtSearch = params.data?.q?.trim() || ''
              if (!txtSearch) {
                return success({
                  results: [],
                })
              }

              // const querys = [
              //   `({textSearch} LIKE '''${txtSearch}''' OR {address} LIKE '''${txtSearch}''')`,
              // ];
              // if (this.moId) {
              //   querys.push(`{merchantOwnerId} == '''${this.moId}'''`);
              // }
              // if (this.maId) {
              //   querys.push(`{mcAccountId} == '''${this.maId}'''`);
              // }
              let queryString = `({textSearch} like '''${txtSearch}''' or {address} like '''${txtSearch}''')`

              if (this.moId) {
                queryString += ` and {merchantOwnerId} == '''${this.moId}'''`
              }
              if (this.maId) {
                queryString += ` and {mcAccountId} == '''${this.maId}'''`
              }

              if (this.selectedStoreList.length > 0) {
                const excludeIds = this.selectedStoreList
                  .map(store => `'''${store.id}'''`)
                  .join(' , ')
                queryString += ` and {id} nin [${excludeIds}]`
              }

              if (this.tLoadStore) {
                clearTimeout(this.tLoadStore)
              }
              this.tLoadMa = setTimeout(() => {
                ListStore({
                  // showFields: ["id", "storeName", "email", "merchantOwnerId", "merchantAccountId"],
                  limit: 10,
                  page: 1,
                  queryString,
                  sort: {
                    direction: 'ASC',
                    properties: ['storeName'],
                  },
                })
                  .then(res => {
                    this.listSearchStore =
                      res.data.listData?.map(item => {
                        return {
                          ...item,
                          id: item.id,
                          text: item.storeName || item.email,
                          merchantOwnerId: item.merchantOwnerId,
                          merchantAccountId: item.merchantAccountId,
                        }
                      }) || []
                    success({
                      results: this.listSearchStore,
                    })
                  })
                  .catch(failure)
              }, 500)
            },
          },
        },
      }
    },

    async created() {
      this.id = this.$router.currentRoute.params.id
      await this.getConfigSystem()
      if (this.id) {
        await this.getContactDetail()
      }
      const queries = this.$router.currentRoute.query
      if (queries.maId && queries.maName) {
        this.selectedMaList = [
          {
            id: queries.maId,
            name: queries.maName,
            role: this.getDefaultRole('ma'),
          },
        ]
      }
    },

    async mounted() {},

    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },

    methods: {
      async getConfigSystem() {
        try {
          const res = await CommonService.getConfigSystem()
          this.moRoles = res.data.moContact?.map(mo => ({
            value: mo.code,
            text: mo.name,
          }))
          this.maRoles = res.data.maContact?.map(ma => ({
            value: ma.code,
            text: ma.name,
          }))
          this.storeRoles = res.data.storeContact?.map(store => ({
            value: store.code,
            text: store.name,
          }))
        } catch (e) {
          showMess(
            this,
            'Error',
            e.response?.data?.message || e.response?.message || e.message,
            'danger',
            'b-toaster-top-right',
            5 * 60 * 60
          )
        }
      },
      async getContactDetail() {
        try {
          this.isLoading = true
          const res = await Detail(this.id)
          this.form = res.data
          this.selectedMaList = res.data.maContacts || []
          this.selectedMoList = res.data.moContacts || []
          this.selectedStoreList = res.data.storeContacts || []
        } catch (e) {
          showMess(
            this,
            'Error',
            e.response?.data?.message || e.response?.message || e.message,
            'danger',
            'b-toaster-top-right',
            5 * 60 * 60
          )
        } finally {
          this.isLoading = false
        }
      },

      async validateForm() {
        const isValid = await this.$refs.observer.validate()
        if (isValid) {
          return true
        }
      },
      async validateContacts() {
        let isValid = true

        // Kiểm tra MO
        // if (this.selectedMoList.length === 0) {
        //   this.moError = "Vui lòng chọn ít nhất một Merchant Owner";
        //   isValid = false;
        // } else {
        const moWithoutRole = this.selectedMoList.filter(mo => !mo.role)
        if (moWithoutRole.length > 0) {
          this.moError = `Vui lòng chọn chức danh cho ${moWithoutRole.length} Merchant Owner`
          isValid = false
        } else {
          this.moError = ''
        }
        // }

        // Kiểm tra MA
        const maWithoutRole = this.selectedMaList.filter(ma => !ma.role)
        if (maWithoutRole.length > 0) {
          this.maError = `Vui lòng chọn chức danh cho ${maWithoutRole.length} Merchant Account`
          isValid = false
        } else {
          this.maError = ''
        }

        // Kiểm tra Store
        const storeWithoutRole = this.selectedStoreList.filter(store => !store.role)
        if (storeWithoutRole.length > 0) {
          this.storeError = `Vui lòng chọn chức danh cho ${storeWithoutRole.length} Cửa hàng`
          isValid = false
        } else {
          this.storeError = ''
        }

        return isValid
      },

      async submitForm() {
        const isValid = await this.validateForm()
        const isContactsValid = await this.validateContacts()
        if (!isValid || !isContactsValid) {
          return showMess(
            this,
            'Error',
            'Hãy kiểm tra lại thông tin nhập',
            'danger',
            'b-toaster-top-right',
            5 * 60 * 60
          )
        }

        this.form.moContactList = this.selectedMoList.map(mo => ({
          id: mo.id,
          role: mo.role,
        }))
        this.form.maContactList =
          this.selectedMaList.map(ma => ({
            id: ma.id,
            role: ma.role,
          })) || []
        this.form.storeContactList =
          this.selectedStoreList.map(store => ({
            id: store.id,
            role: store.role,
          })) || []
        if (this.id) {
          await this.edit()
        }
        if (!this.id) {
          await this.create()
        }
      },

      async create() {
        try {
          this.showLoading = true
          const params = cloneDeep(this.form)
          const res = await Create(params)
          if (res && res.code === 1000) {
            const modal = this.showSuccessMx(res.message)
            modal.then(() => {
              this.$router.push('/customer-support/contact')
            })
          }
        } catch (e) {
          this.showFailMx(e.message)
        } finally {
          this.showLoading = false
        }
      },

      async edit() {
        try {
          this.showLoading = true
          const params = cloneDeep(this.form)
          const res = await Update(params.id, params)
          if (res && res.code === 1000) {
            const modal = this.showSuccessMx(res.message)
            modal.then(() => {
              this.$router.push('/customer-support/contact')
            })
          }
        } catch (e) {
          this.showFailMx(e.message)
        } finally {
          this.showLoading = false
        }
      },
      getDefaultRole(type) {
        switch (type) {
          case 'mo':
            return this.moRoles[0].value
          case 'ma':
            return this.maRoles[0].value
          case 'store':
            return this.storeRoles[0].value
          default:
            return ''
        }
      },
      updateRole(type, id, newRole) {
        const list =
          type === 'mo'
            ? this.selectedMoList
            : type === 'ma'
              ? this.selectedMaList
              : this.selectedStoreList
        const item = list.find(i => i.id === id)
        if (item) {
          item.role = newRole
        }
        this.validateContacts()
      },

      async onChangeMo(val) {
        const selectedMo = this.listSearchMo.find(item => item.id === val)
        if (selectedMo && !this.selectedMoList.some(mo => mo.id === selectedMo.id)) {
          this.selectedMoList.push({
            ...selectedMo,
            role: this.getDefaultRole('mo'),
          })
        }
        this.$refs.moSelect.select2.val(null).trigger('change')
        this.moError = ''
        this.validateContacts()
      },

      async onChangeMa(val) {
        const selectedMa = this.listSearchMa.find(item => item.id === val)
        if (selectedMa && !this.selectedMaList.some(ma => ma.id === selectedMa.id)) {
          this.selectedMaList.push({
            ...selectedMa,
            role: this.getDefaultRole('ma'),
          })
          // Thêm MO liên quan nếu chưa được chọn
          if (selectedMa.merchantOwnerId) {
            const relatedMo = this.listSearchMo.find(mo => mo.id === selectedMa.merchantOwnerId)
            if (relatedMo && !this.selectedMoList.some(mo => mo.id === relatedMo.id)) {
              this.selectedMoList.push({
                ...relatedMo,
                role: this.getDefaultRole('mo'),
              })
            }
          }
        }
        this.$refs.maSelect.select2.val(null).trigger('change')
        this.maError = ''
        this.validateContacts()
      },

      async onChangeStore(val) {
        const selectedStore = this.listSearchStore.find(item => item.id === val)
        if (selectedStore && !this.selectedStoreList.some(store => store.id === selectedStore.id)) {
          this.selectedStoreList.push({
            ...selectedStore,
            role: this.getDefaultRole('store'),
          })
          // Thêm MO và MA liên quan nếu chưa được chọn
          if (selectedStore.merchantOwnerId) {
            const relatedMo = this.listSearchMo.find(mo => mo.id === selectedStore.merchantOwnerId)
            if (relatedMo && !this.selectedMoList.some(mo => mo.id === relatedMo.id)) {
              this.selectedMoList.push({
                ...relatedMo,
                role: this.getDefaultRole('mo'),
              })
            }
          }
          if (selectedStore.merchantAccountId) {
            const relatedMa = this.listSearchMa.find(
              ma => ma.id === selectedStore.merchantAccountId
            )
            if (relatedMa && !this.selectedMaList.some(ma => ma.id === relatedMa.id)) {
              this.selectedMaList.push({
                ...relatedMa,
                role: this.getDefaultRole('ma'),
              })
            }
          }
        }
        this.$refs.storeSelect.select2.val(null).trigger('change')
        this.storeError = ''
        this.validateContacts()
      },
      removeItem(type, id) {
        switch (type) {
          case 'mo':
            this.selectedMoList = this.selectedMoList.filter(mo => mo.id !== id)
            this.selectedMaList = this.selectedMaList.filter(ma => ma.merchantOwnerId !== id)
            this.selectedStoreList = this.selectedStoreList.filter(
              store => store.merchantOwnerId !== id
            )
            break
          case 'ma':
            this.selectedMaList = this.selectedMaList.filter(ma => ma.id !== id)
            this.selectedStoreList = this.selectedStoreList.filter(
              store => store.merchantAccountId !== id
            )
            break
          case 'store':
            this.selectedStoreList = this.selectedStoreList.filter(store => store.id !== id)
            break
        }
        this.validateContacts() // Gọi validate sau khi xóa
      },
    },
  }
</script>

<style scoped lang="scss">
  .header-section {
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    position: relative;
    margin-left: 10px;

    &::before {
      content: ' ';
      position: absolute;
      width: 4px;
      height: 24px;
      background: #13569f;
      left: -10px;
    }
  }

  .form-item {
    &:first-child {
      margin-top: 0;
    }

    .form-label {
      font-weight: 400;
      font-size: 13px;
      color: #2a2a2a;

      &.require::after {
        content: '*';
        color: #f00;
        margin-left: 4px;
      }
    }

    .w-fit-content {
      width: fit-content;
    }

    .form-input {
      width: 60%;

      .error {
        color: #f00;
      }
    }
  }

  .no-data {
    width: 100%;
    color: #999;
    border: 1px solid #ddd;
    height: 60px;
    align-items: center;
    border-radius: 5px;
    display: flex;
    justify-content: center;
  }

  // new css
  .card {
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  .card .box-list {
    border-top: 1px solid #e0e0e0;
  }

  .table-responsive {
    height: 210px;

    .table td,
    .table th {
      padding: 5px 8px;
    }
  }

  .table-mo {
    min-height: 315px;
  }

  .sticky-top {
    position: sticky;
    top: 0;
    // z-index: 1020;
  }
</style>
